import { render, staticRenderFns } from "./Sims.vue?vue&type=template&id=7f543f2e&"
import script from "./Sims.vue?vue&type=script&lang=js&"
export * from "./Sims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports